<script>
    export default {
        props: {
            name: String,
            value: Number,
            changeValue: Function,
        }
    }
</script>


<template>
    <div class="range_container">
        <div class="color_circle" :style="{backgroundColor: name}"></div>
        <input 
            type="range"
            min="0"
            max="255"
            step="1"
            :value="value"
            class="ml_10"
            @input="changeValue($event, name)"
        >
        <label class="ml_10">{{ value }}</label>
    </div>
</template>


<style scoped>
    .range_container {
        display: flex;
        flex-direction: row;
    }
    .color_circle {
        flex: 0 0 13px;
        border-radius: 50%;
        height: 13px;
    }
    label {
        flex: 0 0 30px;
    }
    input[type='range'] {
        flex: 1 1 100%;
        cursor: pointer;
        border: var(--border);
        overflow: hidden;
        -webkit-appearance: none;
        background-color: var(--background);
        border-radius: 10px;
    }
    input[type='range']::-webkit-slider-thumb {
        width: 13px;
        height: 13px;
        -webkit-appearance: none;
        cursor: ew-resize;
        background: var(--main-color);
        box-shadow: -200px 0 0 195px var(--main-color);
        border-radius: 10px;
    }
</style>